import {
    GET_CATERING_DASHBOARD_SUMMARY,
    GET_CATERING_DASHBOARD_SUMMARY_FAILURE,
    GET_CATERING_DASHBOARD_SUMMARY_SUCCESS,
} from '../../../modules/constants';

const initialState = {
    isLoading: false,
    summary: null,
};

const cateringDashboardReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_CATERING_DASHBOARD_SUMMARY:
            return {
                ...state,
                isLoading: true,
            };
        case GET_CATERING_DASHBOARD_SUMMARY_SUCCESS:
            return {
                ...state,
                isLoading: false,
                summary: action.payload.data,
            };
        case GET_CATERING_DASHBOARD_SUMMARY_FAILURE:
            return {
                ...state,
                isLoading: false,
                summary: null,
            };
        default:
            return state;
    }
};

export default cateringDashboardReducer;
